// Browser fingerprint helper using @fingerprintjs/fingerprintjs (open-source).
// Used for referral anti-fraud (detecting self-invites).
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let _agentPromise = null;
let _cached = null;

async function getAgent() {
  if (!_agentPromise) {
    _agentPromise = FingerprintJS.load();
  }
  return _agentPromise;
}

/**
 * Returns the browser fingerprint (visitorId hash). Cached per page-load.
 * Resolves to null on failure (e.g. in privacy modes) – callers must
 * treat the value as optional and not block UX.
 */
export async function getFingerprint() {
  if (_cached) return _cached;
  try {
    const agent = await getAgent();
    const result = await agent.get();
    _cached = result?.visitorId || null;
    return _cached;
  } catch (e) {
    return null;
  }
}

export default getFingerprint;
